'use strict';

const container = require('./../../core/container');
const mediator = require('./../../core/mediator');

let events = {
    'desktop': {
        'application:ready': [
            {'callback': require('./repository/DesignRepository').getAllColors},
            {'callback': require('./repository/DesignRepository').getAllFonts},
            {'callback': require('./repository/DesignRepository').getAllShapes},
        ],
        'menu:more-parameters:ready': [
            {
                'callback': function(items) {
                    if (container.get('isAllowedTo')('CUSTOM_DESIGN_FEATURE')) {
                        items.push({'name': 'design_settings', 'pos': 8});
                    }
                },
            },
        ],
        'menu:more-parameters:design_settings:click': [
            {'callback': require('./../../services/structure/menu/panel').init.bind(undefined, 'design_settings')},
        ],
        'menu:design_settings:ready': [
            {
                'callback': function(items) {
                    items.push({'name': 'color_settings', 'pos': 10});
                    items.push({'name': 'button_settings', 'pos': 20});
                    items.push({'name': 'global_content_settings', 'pos': 30});
                    items.push({'name': 'page_errors_management', 'pos': 40});
                    items.push({'name': 'favicon', 'pos': 50});
                },
            },
        ],
        'menu:design_settings:page_errors_management:click': [
            {'callback': require('./../page/service/errorManagement').onClick},
        ],
        'menu:design_settings:favicon:click': [
            {'callback': require('./../content/listener/favicon').onMenuClick},
        ],
        'menu:design_settings:color_settings:click': [
            {'callback': require('./service/colorManagement').onClick},
        ],
        'menu:design_settings:button_settings:click': [
            {'callback': require('./service/buttonManagement').onClick},
        ],
        'menu:design_settings:global_content_settings:click': [
            {'callback': require('./service/globalContentManagement').onClick},
        ],
        'flash-callback:colors-submit': [
            {'callback': function() {
                mediator.subscribe('after:menu:show', function() {
                    setTimeout(function() {
                        require('./service/colorManagement').afterSubmit();
                    }, 200);
                }, true);
            }},
        ],
    },
    'mobile': {
        'menu:more-parameters:ready': [
            {
                'callback': function(items) {
                    items.push({'name': 'no_design_settings', 'pos': 8, 'class': 'btn-disabled'});
                },
            },
        ],
    },
};

module.exports = {
    'events': events[container.get('isMobile') ? 'mobile' : 'desktop'],
};
